(function () {
  let registry = window.__vxeRegistry || (window.__vxeRegistry = []);
  let swiperPromise = null;

  function loadStylesheet(href) {
    return new Promise(function (resolve, reject) {
      let existing = document.querySelector('link[data-vx-swiper-css="' + href + '"]');
      if (existing) {
        if (existing.getAttribute('data-vx-loaded') === '1' || existing.sheet) {
          resolve();
          return;
        }
        existing.addEventListener('load', function () {
          resolve();
        });
        existing.addEventListener('error', reject);
        return;
      }
      let el = document.createElement('link');
      el.rel = 'stylesheet';
      el.href = href;
      el.media = 'screen';
      el.setAttribute('data-vx-swiper-css', href);
      el.addEventListener('load', function () {
        el.setAttribute('data-vx-loaded', '1');
        resolve();
      });
      el.addEventListener('error', reject);
      document.head.appendChild(el);
    });
  }

  function loadScript(src) {
    window.__vxScripts = window.__vxScripts || {};
    if (!window.__vxScripts[src]) {
      window.__vxScripts[src] = new Promise(function (resolve, reject) {
        let existing = document.querySelector('script[data-vx-swiper-js="' + src + '"]');
        if (existing) {
          if (existing.getAttribute('data-vx-loaded') === '1') {
            resolve();
            return;
          }
          existing.addEventListener('load', function () {
            resolve();
          });
          existing.addEventListener('error', reject);
          return;
        }
        let el = document.createElement('script');
        el.src = src;
        el.defer = true;
        el.setAttribute('data-vx-swiper-js', src);
        el.addEventListener('load', function () {
          el.setAttribute('data-vx-loaded', '1');
          resolve();
        });
        el.addEventListener('error', reject);
        document.head.appendChild(el);
      });
    }
    return window.__vxScripts[src];
  }

  function ensureSwiper(jsSrc, cssSrc) {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (!jsSrc) return Promise.reject(new Error('Missing Swiper src'));
    if (!swiperPromise) {
      swiperPromise = (cssSrc ? loadStylesheet(cssSrc) : Promise.resolve())
        .then(function () {
          return loadScript(jsSrc);
        })
        .then(function () {
          return window.Swiper;
        });
    }
    return swiperPromise;
  }

  function whenNear(el) {
    return new Promise(function (resolve) {
      if (window.Shopify && Shopify.designMode) {
        resolve();
        return;
      }
      if (!('IntersectionObserver' in window)) {
        resolve();
        return;
      }
      let io = new IntersectionObserver(
        function (entries) {
          for (let i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              io.disconnect();
              resolve();
              return;
            }
          }
        },
        { rootMargin: '200px 0px' }
      );
      io.observe(el);
    });
  }

  function unregister(root) {
    for (let i = registry.length - 1; i >= 0; i--) {
      if (registry[i].root === root) {
        if (registry[i].destroy) registry[i].destroy();
        registry.splice(i, 1);
      }
    }
  }

  function cap(count, max) {
    return count < max ? count : max;
  }

  function init(root) {
    if (!root || root.dataset.vxInit) return;
    let swiperEl = root.querySelector('.vx-exp__swiper');
    if (!swiperEl) return;
    root.dataset.vxInit = '1';

    let sectionId = root.dataset.vxExpId || '';
    let swiperJs = root.getAttribute('data-vx-swiper-js') || '';
    let swiperCss = root.getAttribute('data-vx-swiper-css') || '';
    let prev = root.querySelector('.vx-exp__arrow--prev');
    let next = root.querySelector('.vx-exp__arrow--next');
    let count = swiperEl.querySelectorAll('.swiper-slide').length;
    let swiper = null;
    let cancelled = false;
    let reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function onBlockSelect(e) {
      if (!swiper || !e.detail || e.detail.sectionId !== sectionId) return;
      let slide = root.querySelector('.swiper-slide[data-block-id="' + e.detail.blockId + '"]');
      if (!slide) return;
      let index = parseInt(slide.dataset.index, 10);
      if (!isNaN(index)) swiper.slideTo(index);
    }

    document.addEventListener('shopify:block:select', onBlockSelect);

    whenNear(root)
      .then(function () {
        if (cancelled) return;
        return ensureSwiper(swiperJs, swiperCss);
      })
      .then(function (SwiperCtor) {
        if (cancelled || !SwiperCtor || !swiperEl) return;
        swiperEl.classList.add('is-ready');
        swiper = new SwiperCtor(swiperEl, {
          observer: true,
          observeParents: true,
          watchOverflow: true,
          speed: reduce ? 0 : 600,
          spaceBetween: 18,
          slidesPerView: cap(count, 1),
          grabCursor: count > 1,
          rewind: count > 1,
          navigation: {
            prevEl: prev,
            nextEl: next
          },
          breakpoints: {
            750: {
              slidesPerView: cap(count, 2),
              spaceBetween: 24
            },
            990: {
              slidesPerView: cap(count, 3),
              spaceBetween: 32
            }
          }
        });
      })
      .catch(function () {});

    function destroy() {
      cancelled = true;
      document.removeEventListener('shopify:block:select', onBlockSelect);
      if (swiper && swiper.destroy) swiper.destroy(true, true);
      swiper = null;
      swiperEl.classList.remove('is-ready');
    }

    unregister(root);
    registry.push({ root: root, destroy: destroy });
  }

  function boot(scope) {
    let roots = (scope || document).querySelectorAll('[data-vx-exp]');
    for (let i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    let section = event.target;
    if (!section || !section.querySelector) return;
    let root = section.querySelector('[data-vx-exp]');
    if (!root) return;
    unregister(root);
    delete root.dataset.vxInit;
    init(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    let scope = event.target;
    if (!scope) return;
    let el =
      scope.matches && scope.matches('[data-vx-exp]')
        ? scope
        : scope.querySelector && scope.querySelector('[data-vx-exp]');
    if (el) unregister(el);
  });
})();
